// footer.tsx
import { useEffect, useState } from "react";

import { getCurrentUserDetails, getFormattedFullName } from "../utils/Helper";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import AText from "./Text";
import { UserIcon } from "../../../assets/icons/UserIcon";
import { LogoutIcon } from "../../../assets/icons/LogoutIcon";
import ATitle from "./Title";
import { userThunks } from "user/presentation/store/userSlice";
import { useNavigate } from "react-router-dom";
import { color } from "theme/Color";
import { typography } from "theme/Typography";
import { notificationThunks } from "notifications/presentation/store/notificationSlice";
import Loader from "./Loader";

function Footer() {
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userProfile: storedUserProfile, cachedSidebarPermissions } = useAppSelector((state) => state.user);

  const effectiveUser = storedUserProfile?.user
    ? storedUserProfile.user
    : cachedSidebarPermissions
    ? {
        userId: cachedSidebarPermissions.userId,
        firstName: cachedSidebarPermissions.firstName,
        lastName: cachedSidebarPermissions.lastName,
        middleName: cachedSidebarPermissions.middleName,
        email: cachedSidebarPermissions.email,
        roles: cachedSidebarPermissions.roles,
        company: cachedSidebarPermissions.companyName ? { companyName: cachedSidebarPermissions.companyName } : undefined,
      }
    : null;

  const id = effectiveUser?.userId;
  const email = effectiveUser?.email ?? "";
  const roles = effectiveUser?.roles ?? [];

  const company = effectiveUser?.company?.companyName || "";
  const displayName = company
    ? company
    : effectiveUser
    ? getFormattedFullName(effectiveUser.firstName, effectiveUser.lastName, effectiveUser.middleName)
    : "";

  useEffect(() => {
    getCurrentUserDetails(dispatch).catch((error) => {
      console.log("Error fetching user details:", error);
    });
  }, []);

  const userData = {
    id: id,
    isLogin: false,
  };

  const handleLogout = async () => {
    setLoading(true);
    await dispatch(userThunks.userLogout(userData));
    await dispatch(notificationThunks.userLogout());
    setLoading(false);
    navigate("/");
    localStorage.removeItem(`${id}_vehicleOnboardingModalShown`);
  };

  return (
    <>
      <div
        style={{
          borderTop: `1px solid ${color.HR_GREY}`,
          padding: "10px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginLeft: "20px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <UserIcon />
          <div
            style={{
              margin: "5px 5px 5px 10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ATitle
              style={{
                fontSize: typography.fontSizes.sm,
                fontWeight: typography.fontWeights.semibold,
              }}
              content={displayName}
            />
            {roles?.map((role: any, index: number) => (
              <AText key={index} fontSize={typography.fontSizes.xs} fontWeight={typography.fontWeights.bold}>
                {role?.roleName}
              </AText>
            ))}
            <AText fontSize={14}>{email}</AText>
          </div>
        </div>
        <div>{loading ? <Loader height="12px" /> : <LogoutIcon onClick={handleLogout} />}</div>
      </div>
    </>
  );
}

export default Footer;